<template>
  <div class="content">
    <div class="hour-forecast">
      <div class="publish-time" v-if="giftData.ptimestemp">
<!--        <i class="el-icon-time"></i>-->
<!--        数据时间：{{ $moment(giftData.ptimestemp).format('YYYY-MM-DD HH:mm') }}-->
        <div>{{ $moment(giftData.ptimestemp).format('YYYY-MM-DD HH:mm') }}更新</div>
      </div>
      <div class="hour-forecast-wrap">
        <div class="hour-forecast-list" ref="hourForecastList">
          <div :id="cardEchart ? 'card-rain-live-chart' : 'rain-live-chart'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import echarts from '@/config/echarts/index.js'
import { getRainLiveOption } from '@/config/echarts/option/rain-live.js'
import { mapState } from 'vuex'
export default {
  props: ['params', 'forecastType', 'cardEchart'],
  data () {
    return {
      charts: '',
      giftData: {},
      timmer: null
    }
  },
  watch: {
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.getRainLiveData()
        }, 100)
      },
      immediate: true
    },
    forecastType () {
      this.resetEchart()
    },
    slideLiveResult: {
      handler () {
        this.$nextTick(() => {
          this.getRainLiveData()
        })
      },
      deep: true
    }

  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'slideLiveResult'])
  },
  mounted () {
    this.initEchart()
  },
  methods: {
    initEchart () {
      const idName = this.cardEchart ? 'card-rain-live-chart' : 'rain-live-chart'
      const tempChart = echarts.init(document.getElementById(idName))
      tempChart.setOption(getRainLiveOption())
      this.charts = tempChart

      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = document.body.clientWidth / 1920 * 16
        document.getElementsByTagName('html')[0].style.fontSize = this.$rootFontSize + 'px'
        this.charts.resize()
      }

      this.$bus.$on('changeRainLiveResize', () => {
        this.$nextTick(() => { this.charts.resize() })
      })
      this.$bus.$on('changeCardData', () => {
        this.$nextTick(() => { this.charts.resize() })
      })
    },
    // 获取gif预报
    async getRainLiveData () {
      if (!this.charts) {
        this.initEchart()
      }
      if (!this.slideLiveResult.time) {
        return
      }
      const option = getRainLiveOption()
      const xData = this.slideLiveResult.time
      option.xAxis.data = xData
      const excludes = [null, 'null']
      const hourfs = this.slideLiveResult.hourrf.map(hourrf => excludes.includes(hourrf) ? '--' : hourrf)
      option.series[0].data = hourfs
      const totalRainData = []
      let count = 0
      hourfs.forEach(rain => {
        rain = rain === '--' ? 0 : rain
        count = count + rain
        totalRainData.push(count)
      })
      option.series[0].data = hourfs
      option.yAxis[0].max = Math.floor(Math.max(...hourfs) + 2)
      option.yAxis[0].min = 0
      option.yAxis[1].max = Math.floor(Math.max(...totalRainData) + 2)
      option.series[1].data = totalRainData
      this.charts.clear()
      this.charts.setOption(option)
      this.$nextTick(() => {
        this.charts.resize()
      })
    },

    resetEchart () {
      this.$nextTick(() => {
        this.charts.resize()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.5vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  // pointer-events: none;

  .hour-forecast {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .hour-forecast-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      height: calc(100% - 0.52vw);
      margin-top: 0.52vw;
      overflow: hidden;

      .hour-forecast-list {
        width: 100% !important;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #FFF;
          }

          .des {
            font-size: 0.88rem;
            color: #FFF;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #FFF;
          }
        }

        #rain-live-chart,
        #card-rain-live-chart {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/左.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/右.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 6.85rem;

        span {
          font-size: 0.75rem;
          color: #FFF;
        }

        font {
          font-size: 0.88rem;
          color: #FFF;
        }

        img {
          width: 2rem;
        }

        .chart {
          height: 50%;
        }
      }

      #high-low-temp-chart {
        position: absolute;
        left: 2.3rem;
        right: 2.3rem;
        top: 52%;
        height: 45%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}</style>
